import axios from 'axios'

(($) => {
    $(() => {
        const module = $('.container1 .main1 .area-product-faq1, .new-product-view.swr1');
        if (!module.length) return

        const locale = document.documentElement.getAttribute('data-locale') || 'en_GB';
        const newProductCardSelector = $('.new-product-card');
        const productId = newProductCardSelector.data('product-id');
        const productFaqWrapper = document.querySelector('#product_faq');

        if (!productFaqWrapper || !productId) return;

        const init = () => {
            loadProductFaq()
        }

        // Fetch product FAQs
        const loadProductFaq = () => {
            axios.get(`/fetch-product-faq`, {
                params: {
                    productId: productId,
                    locale: locale
                }
            })
                .then(response => {
                    // If no FAQs, clear wrapper
                    if (response.data.length == 0) {
                        productFaqWrapper.innerHTML = "";
                    } else {
                        // Insert FAQs and initialize accordion
                        productFaqWrapper.innerHTML = `<h2>${window.globals.trans('product-page.faq')}</h2>${response.data.productFAQs}`;
                        initAccordion();
                    }
                })
                .catch(err => {
                    console.error('Error loading product faqs:', err);
                });
        };

        // Initialize accordion behavior
        const initAccordion = () => {
            const titles = document.querySelectorAll(".acc__title"); // All accordion titles

            titles.forEach(function (title) {
                title.addEventListener("click", function (e) {
                    e.preventDefault(); // Prevent default action

                    const card = title.closest(".acc__card"); // Parent card
                    const dropDown = card.querySelector(".acc__panel"); // Current panel
                    const acc = title.closest(".acc"); // Accordion wrapper

                    // Close all other panels
                    acc.querySelectorAll(".acc__panel").forEach(function (panel) {
                        if (panel !== dropDown) {
                            slideUp(panel);
                        }
                    });

                    // Toggle active class
                    if (title.classList.contains("active")) {
                        title.classList.remove("active");
                    } else {
                        acc.querySelectorAll(".acc__title.active").forEach(function (activeTitle) {
                            activeTitle.classList.remove("active");
                        });
                        title.classList.add("active");
                    }

                    // Toggle current dropdown
                    slideToggle(dropDown);
                });
            });
        };

        // Slide up (collapse) element
        function slideUp(element) {
            element.style.height = element.offsetHeight + "px";
            element.offsetHeight; // force repaint
            element.style.transition = "max-height 500ms cubic-bezier(0.22, 1, 0.36, 1)";
            element.style.overflow = "hidden";
            element.style.height = "0";

            setTimeout(function () {
                element.style.display = "none";
                element.style.removeProperty("height");
                element.style.removeProperty("overflow");
                element.style.removeProperty("transition");
            }, 300);
        }

        // Slide down (expand) element
        function slideDown(element) {
            element.style.removeProperty("display");
            let display = window.getComputedStyle(element).display;
            if (display === "none") display = "block";
            element.style.display = display;

            let height = element.scrollHeight + "px";

            element.style.height = "0";
            element.style.overflow = "hidden";
            element.style.transition = "max-height 500ms cubic-bezier(0.22, 1, 0.36, 1)";

            element.offsetHeight; // force repaint
            element.style.height = height;

            setTimeout(function () {
                element.style.removeProperty("height");
                element.style.removeProperty("overflow");
                element.style.removeProperty("transition");
            }, 300);
        }

        // Toggle slide up/down
        function slideToggle(element) {
            if (window.getComputedStyle(element).display === "none") {
                slideDown(element);
            } else {
                slideUp(element);
            }
        }

        // Initialize script
        init();

    })
})(jQuery)